import LoadingSpinner from './LoadingSpinner';

/** Design spec: 56px ring from Figma 80px spinner, scaled proportionally */
export default function PageLoaderSpinner() {
    return <LoadingSpinner className='h-full w-full' />;
}
